import React from 'react';

export const AboutUs = () => {
  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold text-black sm:text-5xl">About RigidAthlete</h1>
          <p className="mt-4 text-xl text-black">
            Empower your fitness journey with personalized plans and expert guidance
          </p>
        </div>

        <div className="mt-16 space-y-12">
          <section>
            <h2 className="text-2xl font-bold text-black">Our Mission</h2>
            <p className="mt-4 text-lg text-black">
              At RigidAthlete, we're committed to revolutionizing the way people approach their fitness and nutrition goals.
              Our platform combines cutting-edge technology with proven exercise and nutrition principles to create
              personalized plans that match your unique needs and lifestyle.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black">What Sets Us Apart</h2>
            <div className="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-2">
              <div className="bg-white p-6 rounded-lg shadow border border-black">
                <h3 className="text-xl font-semibold text-black">Personalized Approach</h3>
                <p className="mt-2 text-black">
                  Each plan is tailored to your specific goals, fitness level, and dietary preferences,
                  ensuring a program that works perfectly for you.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow border border-black">
                <h3 className="text-xl font-semibold text-black">Expert Guidance</h3>
                <p className="mt-2 text-black">
                  Our programs are designed by certified fitness professionals and nutritionists with
                  years of experience in the field.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black">Our Story</h2>
            <p className="mt-4 text-lg text-black">
              Founded by a team of fitness enthusiasts and technology experts, RigidAthlete was born from
              the belief that everyone deserves access to professional fitness and nutrition guidance.
              We've combined our passion for health and wellness with innovative technology to create a
              platform that makes achieving your fitness goals more accessible than ever.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black">Join Us Today</h2>
            <p className="mt-4 text-lg text-black">
              Whether you're just starting your fitness journey or looking to take your training to the next level,
              RigidAthlete is here to support you every step of the way. Join our community of dedicated athletes
              and discover the difference that personalized planning can make.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
